/**
 * changes hero img
 * @returns {img} change hero img
 */

const updateBanner = (banners) => {
  const zero = 0;
  console.log(banners);

  $('#top-header').removeClass('ob-custom-banner');

  if ($('.large-header > .custom-hero-img').length !== zero) {
    $('.large-header > .custom-hero-img').remove();
  }

  const $largeHeader = $('.large-header');
  const $gradient = $('.large-header .gradient .header-wrapper');
  const $primaryLogo = $('.header-wrapper.txt .header-main .primary-logo');
  const $tagline = $('.header-wrapper.txt .header-intro h2');

  for (const banner in banners) {
    const bannerInfo = banners[banner];
    if ($('body').hasClass(banner)) {
      $('#top-header').addClass('ob-custom-banner');
      $largeHeader.prepend(
        `<img class="custom-hero-img"  src="${bannerInfo.image}" alt="${bannerInfo.imageDescription}" />`
      );
      $gradient.css('background', bannerInfo.overlay);
      $primaryLogo.text(bannerInfo.title).css('color', bannerInfo.fontColor);
      $tagline.text(bannerInfo.tagline).css('color', bannerInfo.fontColor);
      break;
    }
  }

  if ($('body').hasClass('hub-page') || $('body').hasClass('stream-464748')) {
    $('#top-header').addClass('ob-custom-banner');
    $largeHeader.prepend(
      `<img class="custom-hero-img"  src="${banners.defaultBanner
        .image}" alt="${banners.defaultBanner.imageDescription}" />`
    );
    $gradient.css('background', banners.defaultBanner.overlay);
    $primaryLogo
      .text(banners.defaultBanner.title)
      .css('color', banners.defaultBanner.fontColor);
    $tagline
      .text(banners.defaultBanner.tagline)
      .css('color', banners.defaultBanner.fontColor);
  }
};

export { updateBanner };



// WEBPACK FOOTER //
// ./custom-js/hero.js